import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layout"
import Kv from "../components/Kv"
import Menu from '../components/Menu'
import { Col, Container, Row } from "react-bootstrap"
import BlogItem from "../components/BlogItem"
import {graphql, useStaticQuery} from 'gatsby'
import Style from '../components/Style.module.scss'


const IndexPage = () => {
  const data = useStaticQuery(graphql`
  query {
    allContentfulPortfolioPost {
      edges {
        node {
          title
          slug
          image {
            fluid {
              src
            }
          }
        }
      }
    }
  }
  `)
  return (
    <Layout>
      <Kv/>
      <Menu/>
      <Container>
        <h1 className={Style.exampleCollapseText}>Portfolio</h1>
        <Row>
          {
            data.allContentfulPortfolioPost.edges.map((edge, index) =>(
              <Col className={Style.colCenter} sm ={10} key={index}>
                <BlogItem 
                  title={edge.node.title}
                  src={edge.node.image.fluid.src}
                  link={`/portfolio/${edge.node.slug}`}
                />
              </Col>
            ))
          }
          
        </Row>
      </Container>
    </Layout>
  )

}
export default IndexPage
